import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "./css/navbar.css";
import "./css/front_hig.css";
import "./css/course.css";
import "./css/footer.css";
import "./css/exe.css";
import "./css/group.css";
import "./css/we_are.css";
import "./css/placement.css";
import "./css/teams.css";
import MyComponent  from './App';  // import cheyyunnu
import reportWebVitals from './reportWebVitals';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //passcheyyunnu
  <React.StrictMode>
    <MyComponent /> 
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
